import { createFileRoute } from "@tanstack/react-router";
import LegalPage from "@/pages/site/LegalPage";

export const Route = createFileRoute("/disclaimer")({
  component: () => <LegalPage slug="disclaimer" />,
});
